import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import FloatingActions from './components/FloatingActions';
import GlobalSearchModal from './components/GlobalSearchModal';
import { TourBuilderProvider } from './context/TourBuilderContext';
import Home from './pages/Home';
import Tours from './pages/Tours';
import TourDetails from './pages/TourDetails';
import BookingPage from './pages/Bookingpage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import TourItinerary from './pages/TourItinerary';
import TourBuilderPage from './pages/TourBuilderPage';
import TourPackage from './pages/TourPackage';
import CancellationPolicy from './pages/CancellationPolicy';
import CookiePolicy from './pages/CookiePolicy';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
};

const TourBuilderWithKey = () => {
  const { key } = useLocation();
  return <TourBuilderPage key={key} />;
};

function App() {
  return (
    <Router>
      <TourBuilderProvider>
        <ScrollToTop />
        <div className="min-h-screen flex flex-col">
          <Navbar />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/tours" element={<Tours />} />
              <Route path="/tours/:id" element={<TourDetails />} />
              <Route path="/booking/:tourId" element={<BookingPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/tours/:id/itinerary" element={<TourItinerary />} />
              <Route path="/tours/:id/package" element={<TourPackage />} />
              <Route path="/cancellation" element={<CancellationPolicy />} />
              <Route path="/cookies" element={<CookiePolicy />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<TermsOfService />} />
              <Route path="/tour-builder" element={<TourBuilderWithKey />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
          <Footer />
          <FloatingActions />
          {/* Global search modal — renders the full search flow as an overlay
              on any page when the Tour Builder button is clicked */}
          <GlobalSearchModal />
        </div>
      </TourBuilderProvider>
    </Router>
  );
}

export default App;